import React from 'react';
import { InternalProvider } from '../../util/InternalProvider';
import { StyledTag, TagIconWrapper } from './elements';
import { Icon } from '../Icon';
export var Tag = React.forwardRef(function (_a, fRef) {
    var text = _a.text, _b = _a.type, type = _b === void 0 ? 'gray' : _b, _c = _a.size, size = _c === void 0 ? 'regular' : _c, _d = _a.className, className = _d === void 0 ? '' : _d, iconSrc = _a.iconSrc;
    return (React.createElement(InternalProvider, null,
        React.createElement(StyledTag, { type: type, size: size, className: className, ref: fRef },
            iconSrc && (React.createElement(TagIconWrapper, { size: size },
                React.createElement(Icon, { src: iconSrc, fill: "currentColor", size: "xsmall" }))),
            text)));
});
